module.exports = __webpack_public_path__ + "img/alea-logo.e6936e4e.jpg";